import React, {useEffect, useState} from 'react';
import {QUOTE_PAGES} from "../JobQuotePage";
import Card from "../../components/Card";
import CreateEditOrder from "../../components/job/order/CreateEditOrder";

const ORDER_DEFAULTS = {
    order_type_id:          "",
    user_id:                "",
    production_start_at:    "",
    production_due_at:      "",
    priority:               "",
}

const JobQuoteConvertPage = (props) => {
    const {
        jobId           = null,
        quoteId         = null,
        parentId        = "",
        onChangePage    = (INDEX, quote) => {}
    } = props;

    const handleClose = () => {
        onChangePage(QUOTE_PAGES.INDEX, null);
    }

    const handleComplete = (orderId) => {
        window.location.replace(route('job.order.index', {
            job:    jobId,
            order:  orderId,
        }).toString());
    }

    return (
        <Card
            title={"Convert To Order"}
            classes={"mh-100 border-0"}
            controls={can('viewAny', 'quote') ? (
                <button
                    onClick={(event) => handleClose(event)}
                    className={"btn font-weight-bold btn-outline-eh-off-black px-4 m-0"}
                >
                    <i className={"fa fa-chevron-left mr-2"} />
                    <span>{"Back"}</span>
                </button>
            ) : null}
        >
            <CreateEditOrder
                jobId={jobId}
                quoteId={quoteId}
                orderId={null}
                onCancel={() => handleClose()}
                onComplete={(orderId) => handleComplete(orderId)}
            />
        </Card>
    );
}

export default JobQuoteConvertPage;
